<template>
    <div>
        <v-progress-linear
            color="primary"
            indeterminate
            absolute
            class="loading-overlay" />
        <v-overlay
            contained
            scrim="red"
            class="align-center justify-center loading-overlay" />
    </div>
</template>
<script>
export default {
    name: 'CustomLoadingOverlay',
};
</script>
<style scoped>
.loading-overlay {
    margin-top: 48px;
}
</style>
